import {
  gethardwaremappingData,
  getprovisioningData,
  getprovisioningActionsData,
  getnetworkelementData,
  gethardwareMappingTemplate,
  editHardwareMappingData,
  getProvisioningTemplate,
  dataByIdProvisioning,
  deleteProvisioning,
  getNetworkElementTemplate,
  editNetworkElementData,
  deletenetworkElement, updateNetworkElement,
  createHardwareMapping, createProvisioning,
  createNetworkElement, updateProvisioning,
  updateHardwareMapping, updateprovisioningActions,
} from "@/http/system/provisioningConfig.js";

export default {
  namespaced: true,
  state: {
    hardwareList: [],
    commandList: [],
    provisioningActionList: [],
    networkSystemList: [],
  },
  actions: {
    async sethardwaremappingData({ commit }) {
      try {
        const resp = await gethardwaremappingData();
        commit("SET_HARDWARE_LIST", resp.data);
        return resp;
      } catch (error) {
        throw Error(
          error.message.errors[0].defaultUserMessage ||
          `Api failed with status code: ${error.message.httpStatusCode}`
        );
      }
    },
    async setprovisioningData({ commit }) {
      try {
        const resp = await getprovisioningData();
        commit("SET_COMMAND_LIST", resp.data);
        return resp;
      } catch (error) {
        throw Error(
          error.message.errors[0].defaultUserMessage ||
          `Api failed with status code: ${error.message.httpStatusCode}`
        );
      }
    },
    async setprovisioningActionsData({ commit }) {
      try {
        const resp = await getprovisioningActionsData();
        commit("SET_PROVISIONING_ACTION_LIST", resp.data);
        return resp;
      } catch (error) {
        throw Error(
          error.message.errors[0].defaultUserMessage ||
          `Api failed with status code: ${error.message.httpStatusCode}`
        );
      }
    },
    async setnetworkelementData({ commit }) {
      try {
        const resp = await getnetworkelementData();
        commit("SET_NETWORK_SYSTEM_LIST", resp.data.pageItems);
        return resp;
      } catch (error) {
        throw Error(
          error.message.errors[0].defaultUserMessage ||
          `Api failed with status code: ${error.message.httpStatusCode}`
        );
      }
    },
    async getCreatehardwareMappingTemplate({ commit }, data) {
      try {
        return await gethardwareMappingTemplate(data);
      } catch (error) {
        throw Error(
          error.message.errors[0].defaultUserMessage ||
          `Api failed with status code: ${error.message.httpStatusCode}`
        );
      }
    },
    async seteditHardwareMappingData({ commit }, data) {
      try {
        const resp = await editHardwareMappingData(data);
        return resp;
      } catch (error) {
        throw Error(
          error.message.errors[0].defaultUserMessage ||
          `Api failed with status code: ${error.message.httpStatusCode}`
        );
      }
    },
    async getCreateCommandTemplate({ commit }, data) {
      try {
        return await getProvisioningTemplate(data);
      } catch (error) {
        throw Error(
          error.message.errors[0].defaultUserMessage ||
          `Api failed with status code: ${error.message.httpStatusCode}`
        );
      }
    },
    async seteditdataByIdProvisioning({ commit }, data) {
      try {
        const resp = await dataByIdProvisioning(data);
        return resp;
      } catch (error) {
        throw Error(
          error.message.errors[0].defaultUserMessage ||
          `Api failed with status code: ${error.message.httpStatusCode}`
        );
      }
    },
    async deleteProvisioningCommand({ commit }, data) {
      try {
        const resp = await deleteProvisioning(data);
        return resp;
      } catch (error) {
        throw Error(
          error.message.errors[0].defaultUserMessage ||
          `Api failed with status code: ${error.message.httpStatusCode}`
        );
      }
    },
    async getCreateNetworkElementTemplate({ commit }, data) {
      try {
        return await getNetworkElementTemplate(data);
      } catch (error) {
        throw Error(
          error.message.errors[0].defaultUserMessage ||
          `Api failed with status code: ${error.message.httpStatusCode}`
        );
      }
    },
    async seteditNetworkElementData({ commit }, data) {
      try {
        const resp = await editNetworkElementData(data);
        return resp;
      } catch (error) {
        throw Error(
          error.message.errors[0].defaultUserMessage ||
          `Api failed with status code: ${error.message.httpStatusCode}`
        );
      }
    },
    async setDeletenetworkElement({ commit }, data) {
      try {
        const resp = await deletenetworkElement(data);
        return resp;
      } catch (error) {
        throw Error(
          error.message.errors[0].defaultUserMessage ||
          `Api failed with status code: ${error.message.httpStatusCode}`
        );
      }
    },
    async createHardwareMappingAction({ commit }, data) {
      try {
        return await createHardwareMapping(data);
      } catch (error) {
        throw Error(
          error.message.errors[0].defaultUserMessage ||
          `Api failed with status code: ${error.message.httpStatusCode}`
        );
      }
    },
    async createProvisioningAction({ commit }, data) {
      try {
        return await createProvisioning(data);
      } catch (error) {
        throw Error(
          error.message.errors[0].defaultUserMessage ||
          `Api failed with status code: ${error.message.httpStatusCode}`
        );
      }
    },
    async createNetworkElementAction({ commit }, data) {
      try {
        return await createNetworkElement(data);
      } catch (error) {
        throw Error(
          error.message.errors[0].defaultUserMessage ||
          `Api failed with status code: ${error.message.httpStatusCode}`
        );
      }
    },
    async updateProvisioningAction({ commit }, data) {
      try {
        return await updateProvisioning(data.id, data.data);
      } catch (error) {
        throw Error(
          error.message.errors[0].defaultUserMessage ||
          `Api failed with status code: ${error.message.httpStatusCode}`
        );
      }
    },
    async updateHardwareMappingAction({ commit }, data) {
      try {
        return await updateHardwareMapping(data.id, data.data);
      } catch (error) {
        throw Error(
          error.message.errors[0].defaultUserMessage ||
          `Api failed with status code: ${error.message.httpStatusCode}`
        );
      }
    },

    async updateNetworkElementAction({ commit }, data) {
      try {
        return await updateNetworkElement(data.id, data.data);
      } catch (error) {
        throw Error(
          error.message.errors[0].defaultUserMessage ||
          `Api failed with status code: ${error.message.httpStatusCode}`
        );
      }
    },

    async updateProvisioningActionsAction({ commit }, data) {
      try {
        return await updateprovisioningActions(data.id, data.data);
      } catch (error) {
        throw Error(
          error.message.errors[0].defaultUserMessage ||
          `Api failed with status code: ${error.message.httpStatusCode}`
        );
      }
    },
  },
  mutations: {
    SET_HARDWARE_LIST(state, payload) {
      state.hardwareList = payload;
    },
    SET_COMMAND_LIST(state, payload) {
      state.commandList = payload;
    },
    SET_PROVISIONING_ACTION_LIST(state, payload) {
      state.provisioningActionList = payload;
    },
    SET_NETWORK_SYSTEM_LIST(state, payload) {
      state.networkSystemList = payload;
    },
  },
  getters: {
    gethardwaresList(state) {
      return state.hardwareList;
    },
    getcommandList(state) {
      return state.commandList;
    },
    getprovisioningActionList(state) {
      return state.provisioningActionList;
    },
    getnetworkSystemList(state) {
      return state.networkSystemList;
    },
  },
};
